export default "__VITE_ASSET__26d4fea3__"